import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { routerActions } from 'connected-react-router';
import PriceBS from '../../../containers/PriceBS';
import ButtonBS from '../../common/ButtonBS';
// import Calculator from '../../../containers/Calculator';
import DownloadBitstopApp from '../../../containers/DownloadBitstopApp/DownloadBitstopApp';
import { StartingScreen as i18n } from '../../../middlewares/i18n';
import * as i18nActions from '../../../actions/i18nActions';
import { track } from '../../../helpers/analytics';
import RewardsCenter from '../../common/RewardsCenter/RewardsCenter';
import HelpCenter from '../../../components/common/HelpCenter';
import '../../../styles/StartingScreen/StartingScreen.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CoinsCarousel from './CoinsCarousel';
// import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import * as sessionActions from '../../../actions/sessionActions';
import PriceBSMulticrypto from '../../../containers/PriceBS/PriceBSMulticrypto';
import BuyCryptoCard from './BuyCryptoCard';

class StartingScreen extends Component {
  constructor(props){
    super(props);
    this.state = {
      openCalculator: false,
      // 'rewards' or 'help' or null 
      // rewards opens left side modal and help opens right side modal
      openModal: null,
      centerItem: null,
    };
  }

  handleCenterItemChange = (item) => {
    this.setState({ centerItem: item });
  };

  openCalculator = () => {
    track('Calculator Opened');
    this.setState({ openCalculator: true });
  };

  getCloseSignal = () => {
    this.setState({ openCalculator: false });
  };

  changeLanguage = (lang) => {
    track('Language Changed', {
      language: lang
    });
    this.props.actions.i18n.changeLanguage(lang);
  };

  handleBuyBitcoin = () => {
    // Here we create a new session
    let session_id = this.props.actions.session.createSession()
    track('Transaction Started', {
      session_id: session_id,
      asset_type: 'Crypto'
    });
    this.props.actions.router.push('/select-coin');
  };

  setOpenModal = (modalName) => {
    track('Starting Screen Modal Opened', {
      modal_name: modalName
    });
    this.setState({ openModal: modalName });
  };

  render(){
    const { openModal } = this.state;
    const { i18n: i18nProps } = this.props;

    return(
      <>
        <div className="modal-button-container rewards-center-container">
          <RewardsCenter openModal={openModal} setOpenModal={this.setOpenModal} />          
        </div>
        <div className="modal-button-container help-center-container">
          <HelpCenter openModal={openModal} setOpenModal={this.setOpenModal} />
        </div>
        <div className='starting-container bs-body centered'>
          {/* <Calculator open={this.state.openCalculator} getClose={this.getCloseSignal} />           */}
          <h6 className={`bs-subtitle starting-screen-subtitle-${i18nProps.language.current} no-margin`}>
            {i18n[i18nProps.language.current].title}
          </h6>
          <h6 className='bs-subtitle no-margin phone'>{i18n[i18nProps.language.current].message}</h6>
          <div className="social-container">
            <div className="social-icon">
              <FontAwesomeIcon icon={faFacebookF} />
            </div>
            <div className="social-icon">
              <FontAwesomeIcon icon={faXTwitter} />
            </div>
            <div className="social-icon">
              <FontAwesomeIcon icon={faInstagram} />
            </div>
            <span className="social-text">
              <span className="separator"></span>
              <span className="bitstopofficial">@bitstopofficial</span>
            </span>
          </div>
          {/* <div className='bs-logo-screen starting-logo' /> */}
          <div className='bs-logo-horizontal'></div>
          <div className='price-cont'>
            {/* {this.state.centerItem ?
              <PriceBSMulticrypto className='bs-title' coin={this.state.centerItem}/>
            :
              <PriceBS className='bs-title' withFee={false}/>
            } */}
            {/* <div className='help help-sc' onClick={this.openCalculator}>
              <FontAwesomeIcon icon={faCalculator} size="3x" />
            </div> */}
            {/* <div className='coin-supported-carousel-container'>
              <CoinsCarousel
                coins={this.props.multicrypto.enabledCoins}
                rates={this.props.rate.multicrypto_rates}
                onCenterItemChange={this.handleCenterItemChange}
              />
            </div> */}
            <BuyCryptoCard
              onClick={this.handleBuyBitcoin}
              coins={this.props.multicrypto.enabledCoins}
              rates={this.props.rate.multicrypto_rates}
            />
          </div>
          {/* <ButtonBS onClick={this.handleBuyBitcoin} content={i18n[i18nProps.language.current].action} className='starting-button' /> */}
          <div className='language-buttons-container'>
            <button className={`language-button ${this.props.i18n.language.current === 'en' ? 'selected' : ''}`} onClick={() => this.changeLanguage('en')}>English </button>
            <button className={`language-button ${this.props.i18n.language.current === 'es' ? 'selected' : ''}`} onClick={() => this.changeLanguage('es')}> Español</button>
          </div>
          <DownloadBitstopApp />
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch){
  return{
    actions: {
      i18n: bindActionCreators(i18nActions, dispatch),
      router: bindActionCreators(routerActions, dispatch),
      session: bindActionCreators(sessionActions, dispatch)
    }
  }
}

function mapStateToProps(state){
  return{
    i18n: state.i18n,
    multicrypto: state.multicrypto,
    rate: state.rate,
    i18n: state.i18n
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StartingScreen);